export const UISETTINGSINIT = {
  courtLineColor: "white",
  courtPaintAreaColor: "#e4c490",
  courtPaintAreaUseWoodPattern: true,
  courtMidRangeColor: "#e4c490",
  courtMidRangeUseWoodPattern: true,
  courtOutOfBoundsColor: "#e4c490",
  courtOutOfBoundsUseWoodPattern: true,
  use3DPlayers: true,
};

